<ng-container *transloco="let t">
  <div class="vetlab-form">
    <form [formGroup]="form">
      <mat-card appearance="outlined" [formGroupName]="'vetlabInfo'">
        <mat-card-content>
          <h2>{{ t('VetLab Anamnesis Request') }}</h2>

          <mat-form-field appearance="outline" style="width: 100%">
            <mat-label>{{ t('Lives at') }}</mat-label>
            <mat-select appAutofocus formControlName="livesAt">
              <mat-option [value]="t('Apartment')">{{
                t('Apartment')
              }}</mat-option>
              <mat-option [value]="t('Yard')">{{ t('Yard') }}</mat-option>
              <mat-option [value]="t('House with yard')">{{
                t('House with yard')
              }}</mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="outline" style="width: 100%">
            <mat-label>{{ t('Other animals') }}</mat-label>
            <mat-select formControlName="otherAnimals">
              <mat-option value="yes">{{ t('Yes') }}</mat-option>
              <mat-option value="no">{{ t('No') }}</mat-option>
            </mat-select>
          </mat-form-field>

          @if (form.get(['vetlabInfo', 'otherAnimals'])?.value === 'yes') {
            <div>
              <mat-form-field appearance="outline" style="width: 100%">
                <mat-label>{{ t('Which animals') }}</mat-label>
                <textarea
                  matInput
                  rows="3"
                  formControlName="otherAnimalsDetails"
                ></textarea>
                @if (
                  form
                    .get(['vetlabInfo', 'otherAnimalsDetails'])
                    ?.hasError('required') &&
                  (form.get(['vetlabInfo', 'otherAnimalsDetails'])?.touched ||
                    form.get(['vetlabInfo', 'otherAnimalsDetails'])?.dirty)
                ) {
                  <mat-error>
                    {{ t('This field is required') }}
                  </mat-error>
                }
              </mat-form-field>
            </div>
          }

          <mat-form-field appearance="outline" style="width: 100%">
            <mat-label>{{ t('Been abroad') }}</mat-label>
            <mat-select formControlName="beenAbroad">
              <mat-option value="yes">{{ t('Yes') }}</mat-option>
              <mat-option value="no">{{ t('No') }}</mat-option>
            </mat-select>
          </mat-form-field>

          @if (form.get(['vetlabInfo', 'beenAbroad'])?.value === 'yes') {
            <div>
              <mat-form-field appearance="outline" style="width: 100%">
                <mat-label>{{ t('Where abroad') }}</mat-label>
                <textarea
                  matInput
                  rows="3"
                  formControlName="beenAbroadDetails"
                ></textarea>
                @if (
                  form
                    .get(['vetlabInfo', 'beenAbroadDetails'])
                    ?.hasError('required') &&
                  (form.get(['vetlabInfo', 'beenAbroadDetails'])?.touched ||
                    form.get(['vetlabInfo', 'beenAbroadDetails'])?.dirty)
                ) {
                  <mat-error>
                    {{ t('This field is required') }}
                  </mat-error>
                }
              </mat-form-field>
            </div>
          }

          <mat-form-field appearance="outline" style="width: 100%">
            <mat-label>{{ t('Diet') }}</mat-label>
            <mat-select formControlName="diet">
              <mat-option [value]="t('Cooked')">{{ t('Cooked') }}</mat-option>
              <mat-option [value]="t('Commercial')">{{
                t('Commercial')
              }}</mat-option>
              <mat-option [value]="t('Mixed')">{{ t('Mixed') }}</mat-option>
              <mat-option [value]="t('Dietary supplements')">{{
                t('Dietary supplements')
              }}</mat-option>
            </mat-select>
            @if (
              form.get(['vetlabInfo', 'diet'])?.hasError('required') &&
              (form.get(['vetlabInfo', 'diet'])?.touched ||
                form.get(['vetlabInfo', 'diet'])?.dirty)
            ) {
              <mat-error>
                {{ t('This field is required') }}
              </mat-error>
            }
          </mat-form-field>

          <mat-form-field appearance="outline" style="width: 100%">
            <mat-label>{{ t('Appetite') }}</mat-label>
            <mat-select formControlName="appetite">
              <mat-option [value]="t('Increased')">{{
                t('Increased')
              }}</mat-option>
              <mat-option [value]="t('Normal')">{{ t('Normal') }}</mat-option>
              <mat-option [value]="t('Decreased')">{{
                t('Decreased')
              }}</mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="outline" style="width: 100%">
            <mat-label>{{ t('Thirst') }}</mat-label>
            <mat-select formControlName="thirst">
              <mat-option [value]="t('Increased')">{{
                t('Increased')
              }}</mat-option>
              <mat-option [value]="t('Normal')">{{ t('Normal') }}</mat-option>
              <mat-option [value]="t('Decreased')">{{
                t('Decreased')
              }}</mat-option>
            </mat-select>
          </mat-form-field>

          <h2 style="margin-top: 16px">
            {{ t('Treatment against parasites') }}
          </h2>
          <div style="display: flex; gap: 16px; margin-top: 8px">
            <div style="flex: 1">
              <mat-form-field appearance="outline" style="width: 100%">
                <mat-label>{{ t('Product 1') }}</mat-label>
                <input matInput formControlName="product1" />
              </mat-form-field>

              <mat-form-field appearance="outline" style="width: 100%">
                <mat-label>{{ t('Product 2') }}</mat-label>
                <input matInput formControlName="product2" />
              </mat-form-field>

              <mat-form-field appearance="outline" style="width: 100%">
                <mat-label>{{ t('Product 3') }}</mat-label>
                <input matInput formControlName="product3" />
              </mat-form-field>
            </div>

            <div style="flex: 1">
              <mat-form-field appearance="outline" style="width: 100%">
                <mat-label>{{ t('Frequency product 1') }}</mat-label>
                <input matInput formControlName="freq1" />
              </mat-form-field>

              <mat-form-field appearance="outline" style="width: 100%">
                <mat-label>{{ t('Frequency product 2') }}</mat-label>
                <input matInput formControlName="freq2" />
              </mat-form-field>

              <mat-form-field appearance="outline" style="width: 100%">
                <mat-label>{{ t('Frequency product 3') }}</mat-label>
                <input matInput formControlName="freq3" />
              </mat-form-field>
            </div>
          </div>

          <mat-form-field appearance="outline" style="width: 100%">
            <mat-label>{{ t('Skin changes at disease onset') }}</mat-label>
            <textarea
              matInput
              rows="5"
              formControlName="clinicalHistory"
              placeholder="{{ t('Skin changes at disease onset helper') }}"
            ></textarea>
            @if (
              form
                .get(['vetlabInfo', 'clinicalHistory'])
                ?.hasError('required') &&
              (form.get(['vetlabInfo', 'clinicalHistory'])?.touched ||
                form.get(['vetlabInfo', 'clinicalHistory'])?.dirty)
            ) {
              <mat-error>
                {{ t('This field is required') }}
              </mat-error>
            }
          </mat-form-field>

          <!-- Performed tests textarea -->
          <mat-form-field appearance="outline" style="width: 100%">
            <mat-label>{{ t('Performed tests') }}</mat-label>
            <textarea
              matInput
              rows="4"
              formControlName="requestedTests"
              placeholder="{{ t('Performed tests helper') }}"
            ></textarea>
            @if (
              form
                .get(['vetlabInfo', 'requestedTests'])
                ?.hasError('required') &&
              (form.get(['vetlabInfo', 'requestedTests'])?.touched ||
                form.get(['vetlabInfo', 'requestedTests'])?.dirty)
            ) {
              <mat-error>
                {{ t('This field is required') }}
              </mat-error>
            }
          </mat-form-field>

          <!-- Prescribed therapy textarea -->
          <mat-form-field appearance="outline" style="width: 100%">
            <mat-label>{{ t('Prescribed therapy') }}</mat-label>
            <textarea
              matInput
              rows="4"
              formControlName="prescribedTherapy"
              placeholder="{{ t('Prescribed therapy helper') }}"
            ></textarea>
          </mat-form-field>

          <!-- Pruritus select -->
          <mat-form-field appearance="outline" style="width: 100%">
            <mat-label>{{ t('Pruritus') }}</mat-label>
            <mat-select formControlName="pruritus">
              <mat-option [value]="t('Yes')">{{ t('Yes') }}</mat-option>
              <mat-option [value]="t('No')">{{ t('No') }}</mat-option>
              <mat-option [value]="t('Primary')">{{ t('Primary') }}</mat-option>
              <mat-option [value]="t('Secondary')">{{
                t('Secondary')
              }}</mat-option>
              <mat-option [value]="t('Unknown')">{{ t('Unknown') }}</mat-option>
            </mat-select>
          </mat-form-field>

          <!-- Other manifestations (multi) -->
          <mat-form-field appearance="outline" style="width: 100%">
            <mat-label>{{ t('Other manifestations') }}</mat-label>
            <mat-select formControlName="otherManifestations" multiple>
              <mat-option [value]="t('Licking')">{{ t('Licking') }}</mat-option>
              <mat-option [value]="t('Scratching')">{{
                t('Scratching')
              }}</mat-option>
              <mat-option [value]="t('Biting')">{{ t('Biting') }}</mat-option>
            </mat-select>
          </mat-form-field>

          <!-- Pruritus localization input -->
          <mat-form-field appearance="outline" style="width: 100%">
            <mat-label>{{ t('Pruritus localization') }}</mat-label>
            <input matInput formControlName="pruritusLocalization" />
          </mat-form-field>

          <!-- More scratching select (night/day) -->
          <mat-form-field appearance="outline" style="width: 100%">
            <mat-label>{{ t('More scratching') }}</mat-label>
            <mat-select formControlName="moreScratching">
              <mat-option [value]="t('Night')">{{ t('Night') }}</mat-option>
              <mat-option [value]="t('Daytime')">{{ t('Daytime') }}</mat-option>
            </mat-select>
          </mat-form-field>
          <!-- Steroid effect on pruritus -->
          <mat-form-field appearance="outline" style="width: 100%">
            <mat-label>{{
              t('Effect of corticosteroids on pruritus')
            }}</mat-label>
            <mat-select formControlName="steroidEffect">
              <mat-option [value]="t('Completely resolves')">{{
                t('Completely resolves')
              }}</mat-option>
              <mat-option [value]="t('Improvement')">{{
                t('Improvement')
              }}</mat-option>
              <mat-option [value]="t('No change')">{{
                t('No change')
              }}</mat-option>
            </mat-select>
          </mat-form-field>

          <!-- Pruritus observed at examination -->
          <mat-form-field appearance="outline" style="width: 100%">
            <mat-label>{{ t('Pruritus observed at examination') }}</mat-label>
            <mat-select formControlName="pruritusObserved">
              <mat-option [value]="t('Yes')">{{ t('Yes') }}</mat-option>
              <mat-option [value]="t('No')">{{ t('No') }}</mat-option>
            </mat-select>
          </mat-form-field>
          <!-- Pinopedal reflex present -->
          <mat-form-field appearance="outline" style="width: 100%">
            <mat-label>{{ t('Pinopedal reflex present') }}</mat-label>
            <mat-select formControlName="pinopedalReflex">
              <mat-option [value]="t('Yes')">{{ t('Yes') }}</mat-option>
              <mat-option [value]="t('No')">{{ t('No') }}</mat-option>
            </mat-select>
          </mat-form-field>

          <!-- Skin changes severity -->
          <mat-form-field appearance="outline" style="width: 100%">
            <mat-label>{{ t('Skin changes severity') }}</mat-label>
            <mat-select formControlName="skinChangesSeverity">
              <mat-option [value]="t('Very mild')">{{
                t('Very mild')
              }}</mat-option>
              <mat-option [value]="t('Mild')">{{ t('Mild') }}</mat-option>
              <mat-option [value]="t('Moderate')">{{
                t('Moderate')
              }}</mat-option>
              <mat-option [value]="t('Intense')">{{ t('Intense') }}</mat-option>
              <mat-option [value]="t('Very intense')">{{
                t('Very intense')
              }}</mat-option>
            </mat-select>
          </mat-form-field>
          <!-- Skin changes distribution -->
          <mat-form-field appearance="outline" style="width: 100%">
            <mat-label>{{ t('Skin changes distribution') }}</mat-label>
            <mat-select formControlName="skinChangesDistribution">
              <mat-option [value]="t('Localized')">{{
                t('Localized')
              }}</mat-option>
              <mat-option [value]="t('Multicentric (2–4 sites)')">{{
                t('Multicentric (2–4 sites)')
              }}</mat-option>
              <mat-option
                [value]="t('Generalized (>60% body surface affected)')"
                >{{ t('Generalized (>60% body surface affected)') }}</mat-option
              >
            </mat-select>
          </mat-form-field>
          <!-- Schematic locations: three rows with number input beside textarea -->
          <h2 style="margin-top: 16px">
            {{ t('Schematic locations instruction') }}
          </h2>
          <div
            style="
              display: flex;
              flex-direction: column;
              gap: 12px;
              margin-top: 8px;
            "
          >
            <div style="display: flex; gap: 12px; align-items: flex-start">
              <mat-form-field
                appearance="outline"
                style="width: 120px; flex: 0 0 120px"
              >
                <mat-label>{{ t('Location number 1') }}</mat-label>
                <input
                  matInput
                  type="number"
                  formControlName="distributionNumber1"
                />
              </mat-form-field>
              <mat-form-field appearance="outline" style="width: 100%">
                <mat-label>{{ t('Comment 1') }}</mat-label>
                <textarea
                  matInput
                  rows="3"
                  formControlName="distributionComment1"
                ></textarea>
              </mat-form-field>
            </div>

            <div style="display: flex; gap: 12px; align-items: flex-start">
              <mat-form-field
                appearance="outline"
                style="width: 120px; flex: 0 0 120px"
              >
                <mat-label>{{ t('Location number 2') }}</mat-label>
                <input
                  matInput
                  type="number"
                  formControlName="distributionNumber2"
                />
              </mat-form-field>
              <mat-form-field appearance="outline" style="width: 100%">
                <mat-label>{{ t('Comment 2') }}</mat-label>
                <textarea
                  matInput
                  rows="3"
                  formControlName="distributionComment2"
                ></textarea>
              </mat-form-field>
            </div>

            <div style="display: flex; gap: 12px; align-items: flex-start">
              <mat-form-field
                appearance="outline"
                style="width: 120px; flex: 0 0 120px"
              >
                <mat-label>{{ t('Location number 3') }}</mat-label>
                <input
                  matInput
                  type="number"
                  formControlName="distributionNumber3"
                />
              </mat-form-field>
              <mat-form-field appearance="outline" style="width: 100%">
                <mat-label>{{ t('Comment 3') }}</mat-label>
                <textarea
                  matInput
                  rows="3"
                  formControlName="distributionComment3"
                ></textarea>
              </mat-form-field>
            </div>
          </div>
          <!-- Schematic image -->
          <div style="margin-top: 16px; text-align: center">
            <img
              src="assets/image/forms/vetlab-anamnesticki.png"
              alt="VetLab schematic"
              style="
                max-width: 700px;
                width: 100%;
                height: auto;
                display: block;
                margin: 0 auto;
                border: 1px solid rgba(0, 0, 0, 0.08);
              "
            />
          </div>

          <mat-form-field
            appearance="outline"
            style="width: 100%; margin-top: 16px"
          >
            <mat-label>{{ t('Veterinarian name and surname') }}</mat-label>
            <input matInput formControlName="veterinarianName" />
            <mat-error>{{ t('This field is required') }}</mat-error>
          </mat-form-field>
        </mat-card-content>
      </mat-card>
    </form>
  </div>
</ng-container>
